import { catchError, finalize, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { FilterDTO, ProductAssetClient, ProductAssetDTOStargate, SortDirection, UpdateAssetDTO } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ErrorType } from 'src/app/core/routing/error-types';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ProductAssetsService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private productAssetClient: ProductAssetClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.productAssetClient.searchProductAssets(skip, take, sortBy, sortDirection, false, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateProductAssets(data: UpdateAssetDTO) {
    this.spinnerService.show();
    return this.productAssetClient.updateAsset(data).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.product-assets.edit-asset.messages.update.success-title',
          'i18n.domain.assets.product-assets.edit-asset.messages.update.success-message');
      }),
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError(err => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.domain.assets.product-assets.edit-asset.messages.update.fail-title',
            'i18n.domain.assets.product-assets.edit-asset.messages.update.fail-message', null, ErrorType.serverError);
        }
        return throwError(() => err);
      })
    );
  }

  public deleteProductAsset(id: number) {
    return this.productAssetClient.deleteAsset(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.assets.product-assets.edit-asset.messages.delete.success-title',
            'i18n.domain.assets.product-assets.edit-asset.messages.delete.success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError(
              'i18n.domain.assets.product-assets.edit-asset.messages.delete.fail-title',
              'i18n.domain.assets.product-assets.edit-asset.messages.delete.fail-message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public setAssetAsKey(id: number): Observable<ProductAssetDTOStargate> {
    return this.productAssetClient.setAssetAsKey(id);
  }

  public setAssetShopAsKey(assetId: number, shopId: string): Observable<void> {
    return this.productAssetClient.setAssetShopAsKey(assetId, shopId);
  }

  public setNewOrderIndex(assetId: number, orderIndex: number): Observable<void> {
    return this.productAssetClient.setNewOrderIndex(assetId, orderIndex);
  }

  public copyAsset(assetId: number, targetItemNo: string, orderIndex: number): Observable<void> {
    return this.productAssetClient.copyAsset(assetId, targetItemNo, orderIndex)
    .pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.product-assets.edit-asset.messages.copy.success-title',
          'i18n.domain.assets.product-assets.edit-asset.messages.copy.success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError(
              'i18n.domain.assets.product-assets.edit-asset.messages.copy.fail-title',
              'i18n.domain.assets.product-assets.edit-asset.messages.copy.fail-message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
    );
  }
}
